import Cookie from 'js-cookie';
import jwt from 'jsonwebtoken';
import API from '../api/api';

class Auth {
  requestPassword = async email => {
    return await API.fetch('/auth/request-password', {
      method: 'POST',
      body: JSON.stringify({
        email,
      }),
    });
  };

  verifyResetToken = async token => {
    const res = await API.fetch('/auth/verify-token?token=' + token, {
      method: 'GET',
    });

    return res.ok;
  };

  resetPassword = async (password, confirmPassword, token) => {
    return await API.fetch('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({
        password,
        confirmPassword,
        token,
      }),
    });
  };

  login = async (username, password) => {
    return new Promise((resolve, reject) => {
      API.fetch('/auth/login', {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept:
            'application/json, application/xml, text/plain, text/html, *.*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: username.toLowerCase(),
          password: password,
        }),
      })
        .then(res => res.json())
        .then(json => resolve(json))
        .catch(err => reject(err));
    });
  };

  logout = () => {
    return new Promise(resolve => {
      Cookie.remove('jwt');
      resolve();
    });
  };

  getToken = () => {
    const encoded = Cookie.get('jwt');

    if (encoded) {
      const decoded = jwt.decode(encoded);
      if (Date.now() > decoded.expires) {
        Cookie.remove('jwt');
        return null;
      }

      return decoded;
    }

    return null;
  };

  isValidToken = () => {
    const token = this.getToken();

    return token && token.expires > Date.now();
  };
}
export default new Auth();
